import type { UIEvent } from 'react';
import { useHistory } from 'react-router-dom';

import type { DataTracking } from 'core/middlewares/trackingGA4';
import { app } from 'core';

export const useLogout = () => {
  const history = useHistory();

  const { trackClick } = app.commands.useAppCommand();

  const handleLogout = (event: UIEvent<HTMLButtonElement>) => {
    const trackData = {
      eventAction: 'clique:submenu',
      eventCategory: 'geral',
      eventLabel: 'logout',
    } as DataTracking;

    trackClick(event, 'event', trackData);
    history.push('/logout');
  };

  return { handleLogout };
};
